import React, { useState } from "react";
import axios from "axios";

const JSONUserUploader = () => {
  const [jsonInput, setJsonInput] = useState("");
  const [error, setError] = useState(null);

  const handleInputChange = (e) => {
    setJsonInput(e.target.value);
    setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let parsedData;
    try {
      parsedData = JSON.parse(jsonInput);
      if (!Array.isArray(parsedData)) {
        throw new Error("JSON must be an array of user objects");
      }
    } catch (err) {
      setError("Invalid JSON: " + err.message);
      return;
    }

    try {
      const response = await axios.post("/user/create/", parsedData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      alert("Users created successfully!");
      console.log(response.data);
    } catch (err) {
      console.error(err);
      alert(err);
    }
  };

  return (
    <div className="p-4 max-w-xl mx-auto bg-white shadow rounded">
      <h2 className="text-xl font-bold mb-4">Upload JSON to Create Users</h2>
      <form onSubmit={handleSubmit}>
        <textarea
          value={jsonInput}
          onChange={handleInputChange}
          placeholder="Paste JSON array of user objects here..."
          rows={15}
          className="w-full p-2 border border-gray-300 rounded mb-2 font-mono text-sm"
        />
        {error && <div className="text-red-600 text-sm mb-2">{error}</div>}
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default JSONUserUploader;
